export const Light = 'Light'
export const Dark = 'Dark'